function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#dc3c4e",
    viewBox: "0 0 24 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 5.25h-3.559a1.25 1.25 0 0 1-1.186-.85l-.316-.95a1.75 1.75 0 0 0-1.66-1.2H9.721a1.745 1.745 0 0 0-1.66 1.2l-.316.948a1.25 1.25 0 0 1-1.186.855H3a.75.75 0 0 0 0 1.5h1.3l.767 11.5a3.76 3.76 0 0 0 3.742 3.5h6.386a3.76 3.76 0 0 0 3.742-3.5L19.7 6.75H21a.75.75 0 0 0 0-1.5M9.483 3.921a.25.25 0 0 1 .238-.171h4.558a.25.25 0 0 1 .238.17l.316.95a3 3 0 0 0 .161.38H9.006a3 3 0 0 0 .161-.381Zm7.955 14.229a2.255 2.255 0 0 1-2.245 2.1H8.807a2.255 2.255 0 0 1-2.245-2.1L5.8 6.75h.757a3 3 0 0 0 .317-.025A1 1 0 0 0 7 6.75h10a1 1 0 0 0 .124-.025 3 3 0 0 0 .317.025h.759ZM14.75 11v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 1.5 0m-4 0v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 1.5 0",
    "data-name": "trash-Regular",
    style: {
      fill: "#dc3c4e"
    }
  }));
};
export default SvgTrash;